import {EMAIL_OR_PASS_MATCHED} from '../Components/Login/loginForm';
import { PARTNER_ACTIVE } from '../Reducers/partnerActiveReducer';
import {clearJwtToken, storeJwtToken} from "../Util/localCache";
import {findPartnerLoginInfo} from "../Util/queries";


const verifyEmailAndPass = (email, pass) =>
    async (dispatch) => {
        try {
            let response = await findPartnerLoginInfo({email: email, password: pass})
            if (response?.data?.accessToken) {
                storeJwtToken(response.data.accessToken);
                dispatch({type: EMAIL_OR_PASS_MATCHED, payload: true});
                dispatch({type: PARTNER_ACTIVE, payload: {active: response.data.partnerActive}});
            } else {
                dispatch({type: EMAIL_OR_PASS_MATCHED, payload: false});
            }
        } catch (e) {
            console.error(e)
            dispatch({type: EMAIL_OR_PASS_MATCHED, payload: false});
        }
    }


const logout = () => async dispatch => {
    clearJwtToken();
    dispatch({type: EMAIL_OR_PASS_MATCHED, payload: null});
    window.location.reload(false);
}

export default verifyEmailAndPass;
export {logout};
